import UserCard from './user-card/UserCard';
import UserItemPage from './item-page/ItemPage';
import CreateUserPage from './create-item/CreateItem';
import ViewUserPage from './view-item/ViewItem';
import EditUserPage from './edit-item/EditItem';

const PlansENUM = {
  platinum: 'platinum',
  gold: 'gold',
  free: ''
};

interface UserItemProps {
  data: UserDataProps;
}

const PARTNER_ROLE_NAME = 'Partner';

interface UserDataProps {
  _id: string;
  email_address: string;
  first_name: string;
  last_name: string;
  source?: string;
  admin_right?: boolean;
  email_verified?: boolean;
  awayz_access?: any;
  password?: string;
  user_roles?: string[];
  influencer_links?: InfluencerLink[];
  requestLimit: string | number;
  userRegion: string;
  partner_category: PartnerCategoryProps;
}

type PartnerCategoryProps = {
  primary: string;
  secondary: string;
};

type SelectOptionProps = {
  label: string;
  value: string;
};
interface InfluencerLink {
  code?: string;
  url?: string;
}

interface UserRegion {
  _id: string;
  name: string;
  code: string;
  currency: string;
  is_active: boolean;
  flag_icon: string;
}

export {
  UserCard,
  CreateUserPage,
  ViewUserPage,
  EditUserPage,
  UserItemPage,
  UserItemProps,
  PlansENUM,
  UserDataProps,
  InfluencerLink,
  UserRegion,
  SelectOptionProps,
  PARTNER_ROLE_NAME
};
